import { Image } from "antd";
import { authorizeSelectors } from "../store/authorize";
import { useSelector } from "../store/store";
import SmallLogo from "./../slogo.png";

export interface LogoProps {
  readonly className?: string;
}

function Logo(props: LogoProps) {
  const user = useSelector(authorizeSelectors.user);

  const logo = user?.companyProfile?.logoBase64
    ? "data:image/jpeg;base64," + user?.companyProfile?.logoBase64
    : SmallLogo;
  return <img className={props.className} src={logo} alt="Logo" />;
}

export default Logo;
